import { type FC } from "react";
import { type MatrixClient } from "matrix-js-sdk";
import { Trans, useTranslation } from "react-i18next";
import { Heading, Text } from "@vector-im/compound-web";

import styles from "./CallEndedView.module.css";
import { useProfile } from "../profile/useProfile";
import { Header, HeaderLogo, LeftNav, RightNav } from "../Header";
import { Link } from "../button/Link";
import { LinkButton } from "../button";

interface Props {
  client: MatrixClient;
  isPasswordlessUser: boolean;
  hideHeader: boolean;
  confineToRoom: boolean;
  endedCallId: string;
}

export const CallEndedView: FC<Props> = ({
  client,
  isPasswordlessUser,
  hideHeader,
  confineToRoom,
}) => {
  const { t } = useTranslation();

  const { displayName } = useProfile(client);

  const createAccountDialog = isPasswordlessUser && (
    <div className={styles.callEndedContent}>
      <Trans i18nKey="call_ended_view.create_account_prompt">
        <p>Why not finish by setting up a password to keep your account?</p>
        <p>
          You'll be able to keep your name and set an avatar for use on future
          calls
        </p>
      </Trans>
      <LinkButton className={styles.callEndedButton} to="/register">
        {t("call_ended_view.create_account_button")}
      </LinkButton>
    </div>
  );

  return (
    <>
      {!hideHeader && (
        <Header>
          <LeftNav>{!confineToRoom && <HeaderLogo />}</LeftNav>
          <RightNav />
        </Header>
      )}
      <div className={styles.container}>
        <main className={styles.main}>
          <Heading size="xl" weight="semibold" className={styles.headline}>
            {t("call_ended_view.headline", { displayName })}
          </Heading>
          {isPasswordlessUser ? createAccountDialog : (
            <div className={styles.callEndedContent}>
              <p>{t("call_ended_view.not_now_button")}</p>
            </div>
          )}
        </main>
        {!confineToRoom && (
          <Text className={styles.footer}>
            <Link to="/"> {t("call_ended_view.not_now_button")} </Link>
          </Text>
        )}
      </div>
    </>
  );
};
